import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useSearchParams } from 'react-router';
import { selectUser } from '@store/accountSlice';

export type AvaillableRoles = 'Everyone' | 'SystemAdmin' | 'ClientAdmin' | 'ClientUser';

function RequireAuth({ permittedRoles = ['Everyone'], children }: Readonly<{
  permittedRoles?: AvaillableRoles[],
  children: React.ReactElement
}>) {
  const user = useSelector(selectUser);
  const location = useLocation();
  const [queryParameters] = useSearchParams();

  // On est loggé
  if (user) {
    // On a les droits nécessaires
    if (permittedRoles.includes('Everyone') || permittedRoles.some(role => user.roles.includes(role)))
      return children;

    // On n'a pas les droits nécessaires
    return (
      <Navigate
        to="/login"
        state={{ from: location, message: 'Vous n\'avez pas les droits nécessaires pour accéder à cette page' }}
        replace
      />);

  }

  // Check si on peut logger avec un token dans url
  const token = queryParameters.get('token');

  // Pas de token dans l'url, on va au login
  if (!token)
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );

  // On log avec le token
  // dispatch(loginWithToken(token));

  return (
    <Navigate
      to={location}
      replace
    />
  );
}

export default RequireAuth;
